<script lang="ts">
    import { appManager } from "../../AppManager";
    import type { VehiclesManager } from "./VehiclesManager";

    export let manager: VehiclesManager;
    let vehicles = manager.getVehicles();
    let visibleVehicles = manager.getVisbleVehiclesStore();
</script>

{#each vehicles as vehicle}
    <button
        title={vehicle.name}
        on:click={() => visibleVehicles.toggle(vehicle.id)}
        class="btn {$visibleVehicles.has(vehicle.id) ? 'active' : ''}">
        <img
            src="{appManager.PublicUrl}icons/vehicles/{vehicle.logo}.svg"
            alt="" />
    </button>
{/each}

<style>
    img {
        height: 30px;
    }

    button {
        padding: 1px;
        margin-right: 1px;
        width: 45px;
        height: 40px;
    }

    .btn > img {
        max-height: unset;
        opacity: 0.4;
    }

    .btn.active img {
        opacity: 1;
    }
</style>
